import { Command } from '../../_base/actionBus/Command';

export class Logout extends Command {}